// export const localUrl = 'http://192.168.1.13:8003/api/v1/web/';
export const localUrl = "https://apipackages.connections.be:8080/api/v1/web/";
// export const localUrl = "https://apicnx.cloudworking.be/api/v1/web/";
// export const localUrl = "http://127.0.0.1:8080/api/v1/web/";
// export const frontEndUrl = 'http://127.0.0.1:3000/'
export const frontEndUrl = 'https://packages.connections.be/'
